import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2100c6cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "search-icon" }
const _hoisted_3 = ["disabled"]

import { Select } from '@/components';
import type { DefaultOptionType, SelectValue } from 'ant-design-vue/lib/select';
import { Search } from '@/components/icons';
import { ref, StyleValue, VNode, useSlots, cloneVNode, watchEffect } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  props: {
    value: {},
    width: {},
    style: {},
    showAllow: { type: Boolean },
    showIcon: { type: Boolean },
    dropdownWidth: {},
    dropdownStyle: {}
  },
  emits: ["update:value", "change"],
  setup(__props: any, { emit }) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/09/06 16:58:20
 * @description: 搜索下拉框
 */


const slots = useSlots();
const cloneOptionNode = ref<VNode>();
const handleChange = (value: string) => {
  emit('change', value);
  emit('update:value', value);
};
const searchData = ({ target }: any) => {
  cloneOptionNode.value = cloneVNode(slots.default?.()[0] as VNode);
  if (cloneOptionNode.value?.children) {
    cloneOptionNode.value.children = (slots.default?.()[0].children as Array<VNode>)?.filter(node =>
      String(node.key).includes(target.value),
    );
  }
};

watchEffect(() => {
  cloneOptionNode.value = cloneVNode(slots.default?.()[0] as VNode);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Select), {
    value: _ctx.value,
    style: _normalizeStyle(_ctx.style),
    "dropdown-style": _ctx.dropdownStyle,
    "dropdown-width": _ctx.dropdownWidth,
    "show-icon": _ctx.showIcon,
    "show-allow": _ctx.showAllow,
    onChange: handleChange
  }, {
    search: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_unref(Search), { style: {"color":"#307dff"} })
        ]),
        _createElementVNode("input", {
          disabled: !_unref(slots).default?.()[0].children?.length,
          class: "search-input",
          type: "text",
          onInput: searchData
        }, null, 40, _hoisted_3)
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(cloneOptionNode.value)))
    ]),
    _: 1
  }, 8, ["value", "style", "dropdown-style", "dropdown-width", "show-icon", "show-allow"]))
}
}

})